import { call } from 'redux-saga/effects';
import * as Api from '../../../../../services/fbm-api';
import { fetchInventoryTagItemCount as fetchInventoryTagItemCountRoutine } from './routines';
import { sagaRoutineRequest } from '../../../../../helpers/saga';

export const fetchInventoryTagItemCount = ({ payload: id }) =>
  sagaRoutineRequest(fetchInventoryTagItemCountRoutine, {
    request: () => call(Api.fetchInventoryTagItemCount, id)
  });
